import { useQuery } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function fetchHistoricalWeatherData(parcel_id, from_date, to_date, language) {
    const data = await client(`parcels/${parcel_id}/historical-weather-data/?from=${from_date}&to=${to_date}&language=${language}`)
    return data
}

export function useHistoricalWeatherData(parcel_id, from_date, to_date, language) {
    return useQuery(['historical-weather-data', parcel_id, from_date, to_date, language], () => fetchHistoricalWeatherData(parcel_id, from_date, to_date, language), {
        enabled: false,
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}
